import React from 'react'
import './consulting-section.scss'
import { StaticImage } from 'gatsby-plugin-image'
import useMediaQuery from '@/utils/useMediaQuery'
import { siteUrl } from '../../../shared/utils/siteUrl'
import { callModal } from '../modal-viewer/modal-viewer'
import Button from '@/components/atoms/button/button'
import { LOCALE_AT } from '@/constants/activity-constants'
import { triggerTageo } from '@/utils/tagging-util'
const $TIENES = LOCALE_AT.PARAGUAY ? 'TENÉS' : 'TIENES'
const $consulta = LOCALE_AT.PARAGUAY ? 'Consultá' : 'Consulta'
const bannerImage = isMobile => {
  return (
    <StaticImage
      src="../../../assets/images/psicologa.webp"
      alt="loving-banner"
      className="f-banner-consulting-image"
      placeholder="blurred"
      height={544}
    />
  )
}
const ConsultingSection = () => {
  const isMobile = useMediaQuery()
  const handlerClick = () => {
    callModal('login', {
      forAccess: 'consultar con la psicóloga',
      onClose: logged => {
        if (logged) {
          triggerTageo('9A', {
            label: 'Consultar',
            location:
              window.location.host + window.location.pathname + '#consultorias',
          })
          window.open(siteUrl + '/entre-nosotras/consultorios/loving', '_blank')
        }
      },
    })
  }
  return (
    <>
      <div className="f-banner-consulting">
        <div className="f-banner-consulting-text">
          <h2>
            EL BULLYING ES UNA PROBLE
            <span className="breaker">
              -<br />
            </span>
            MÁTICA
          </h2>
          <p>QUE NOS PUEDE TOCAR A TODOS</p>
        </div>

        <div className="consultin-wrapper">{!isMobile && bannerImage()}</div>
        <div className="f-banner-consulting-redirect">
          <p className="f-banner-consulting-redirect-text">
            SI {$TIENES} DUDAS O NECESITAS AYUDA TE APOYAMOS
          </p>
          <div className="consultin-wrapper">{isMobile && bannerImage()}</div>
          <div className="f-banner-consulting-redirect-button">
            <p>
              <b>¡{$consulta} gratis</b> con nuestra psicóloga!
            </p>
            {/* <a onClick={handlerClick}>Consultar</a> */}
            <Button onClick={handlerClick} title="ir a consultorios bullyng">
              Consultar
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default ConsultingSection
